
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
	props: {
		endpointId: {
			type: String,
			required: true,
		}
	},
	setup() {
		const store = useStore();

		// Computed active frame
		const activeFrame = computed((): string => store.getters.get_activeFrame);
		return { activeFrame }
	},
})
